module.exports = __webpack_public_path__ + "static/media/logo-blue.15a8337d.svg";